/**
 * This is the summary cart controller.
 *
 * @param rootElementId
 * @return void
 */
window.SummaryCartController = function(rootElementId)
{
    /**
     * @var Object
     *
     * Define the base Vue skeleton to be extended.
     */
    this.VueSkeleton =
    {
        el: '#'+ rootElementId,

        data:
        {
            /**
             * Declare the summary cart.
             *
             * @var Object
             */
            cart: SummaryCart
        },
    };
}
